import { useEffect } from 'react';

export default function TwitterEmbed({ updateOn }: any) {
  useEffect(() => {
    let script: HTMLScriptElement | null = null;
    try {
      script = document.createElement('script');
      script.src = 'https://platform.twitter.com/widgets.js';
      script.setAttribute('data-twitter-embed', 'true');
      document.body.appendChild(script);
    } catch {
      /*swallow exception*/
    }

    // Cleanup script on unmount to prevent orphaned nodes
    return () => {
      try {
        if (script?.parentNode) {
          script.parentNode.removeChild(script);
        }
      } catch {
        // Script already removed, safe to ignore
      }
    };
  }, [updateOn]);

  return null;
}
